export default __webpack_public_path__ + "static/studycafe-study2-adedc4698c3e3611b113ddadf48880e8.jpg";